__turbopack_context__.v({
  "className": "clashgrotesk_b5eed55c-module__SsTZpq__className",
  "variable": "clashgrotesk_b5eed55c-module__SsTZpq__variable",
});
